import { CircularProgress } from "@mui/material";
import React from "react";

export default function CustomButton({
  label,
  isLoading = false,
  onPress,
  fullWidth = true,
  isEnabled = true,
  customLoadingMessage = "Please wait...",
  bgColor = "bg-blue-600",   // ✅ background color
  textColor = "text-white",  // ✅ text color
  outline = false,           // ✅ new prop for outline mode
}) {
  const baseClasses =
    "py-3 text-md font-semibold rounded-lg transition disabled:opacity-50 flex items-center justify-center";

  const solidClasses = `${bgColor} ${textColor} hover:opacity-90`;
  const outlineClasses = `border ${bgColor.replace("bg-", "border-")} ${bgColor.replace(
    "bg-",
    "text-"
  )} bg-transparent hover:${bgColor} hover:${textColor}`;

  return (
    <button
      disabled={isLoading || !isEnabled}
      onClick={isEnabled ? onPress : null}
      className={`${fullWidth ? "w-full" : ""} px-4 ${baseClasses} ${outline ? outlineClasses : solidClasses
        }`}
    >
      {isLoading ? (
        <div className="flex items-center justify-center space-x-2">
          <CircularProgress size={20} color="inherit" />
          <span>{customLoadingMessage}</span>
        </div>
      ) : (
        label
      )}
    </button>
  );
}
